import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import MainContainer from './components/MainContainer';
import {store} from "./redux/store/index";
import '@scss/menu.scss';
import '@scss/fields.scss';
import {SnackbarProvider} from 'notistack';
import {sentryInstance} from '@services/sentry';
import './language/i18n';
import LanguageService from '@services/language/LanguageService';

new sentryInstance();

LanguageService.setLang(LanguageService.getLang() || 'ru')

ReactDOM.render(
    <Provider store={store}>
        <SnackbarProvider>
            <MainContainer />
        </SnackbarProvider>
    </Provider>,
    document.getElementById('profile-container')
);
